var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont_principal"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"container-fluid"},[_c('h3',{staticClass:"title"},[_vm._v("A PROPOS DE MOI")]),_c('h5',{staticClass:"description",staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(_vm.description)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }